/** Days before contract end when extension CTA becomes visible on Overview. */
export const CONTRACT_EXTENSION_WARNING_DAYS = 6;

export function contractDaysLeft(contractEnd, now = new Date()) {
  if (!contractEnd) return null;
  return Math.ceil((new Date(contractEnd) - now) / 86400000);
}

export function todayISO() {
  return new Date().toISOString().split("T")[0];
}

export function minRequestedEnd(contractEnd) {
  if (!contractEnd) return todayISO();
  const end = String(contractEnd).split("T")[0];
  const d = new Date(end + "T00:00:00");
  d.setDate(d.getDate() + 1);
  const min = d.toISOString().split("T")[0];
  const today = todayISO();
  return min > today ? min : today;
}

export function shouldShowContractExtensionBanner(stats) {
  if (!stats?.contract_end) return false;
  const daysLeft = contractDaysLeft(stats.contract_end);
  if (daysLeft !== null && daysLeft <= CONTRACT_EXTENSION_WARNING_DAYS) return true;
  const access = stats.license_access;
  return access && access !== "ACTIVE";
}

export function contractExtensionBannerMessage(stats) {
  const daysLeft = contractDaysLeft(stats?.contract_end);
  const endLabel = stats?.contract_end
    ? new Date(stats.contract_end).toLocaleDateString()
    : "—";
  const access = stats?.license_access;

  if (access === "HARD_LOCK") {
    return daysLeft !== null && daysLeft < 0
      ? `Your contract expired on ${endLabel}. The platform is in read-only lock. Request an extension for platform admin approval.`
      : `Your licence is locked. Request a contract extension for platform admin approval.`;
  }
  if (access === "GRACE") {
    return `Your contract expired on ${endLabel}. You are in the grace period — request an extension before access is fully locked.`;
  }
  if (access === "READ_ONLY") {
    return `Your contract expired on ${endLabel}. The tenant is read-only until an extension is approved.`;
  }
  if (daysLeft !== null && daysLeft <= 0) {
    return `Your contract ended on ${endLabel}. Request an extension for platform admin approval.`;
  }
  if (daysLeft === 1) {
    return `Your contract expires tomorrow (${endLabel}). Request an extension if you need to continue.`;
  }
  return `Your contract expires in ${daysLeft} days (${endLabel}). Request an extension if you need to renew.`;
}
